import { Field, useFormikContext } from 'formik';
import React, { FC, ReactElement } from 'react';
import { Rating } from 'react-simple-star-rating';
import cn from 'classnames';

interface Props {
  name: string;
  label?: string | ReactElement;
  required?: boolean;
}

const StarsFormField: FC<Props> = ({ label, name, required }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <Field name={name} required={required}>
      {({ field, meta }) => {
        const isRegularFieldError = meta.touched && meta.error;

        return (
          <>
            <div className="flex w-full">
              <div className="flex flex-col space-y-0.5">
                {label && (
                  <div
                    className={cn(
                      'pl-1.5 mb-2 text-shuttleGray',
                      required && 'compendium-required-input-style'
                    )}
                  >
                    {label}
                  </div>
                )}
                <div className="flex">
                  <Rating
                    initialValue={field.value}
                    disableFillHover
                    allowHover={false}
                    allowFraction={true}
                    emptyStyle={{ display: 'flex' }}
                    SVGstyle={{ display: 'inline-block' }}
                    onClick={(value) => setFieldValue(name, value)}
                  />
                </div>
                {isRegularFieldError && (
                  <p className="fs-caption-reg text-vermilion">{meta.error}</p>
                )}
              </div>
            </div>
          </>
        );
      }}
    </Field>
  );
};

export default StarsFormField;
